var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/TreeContextMenu/TreeContextMenu.tsx";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React, { useCallback, useMemo } from 'react';
import { isBimNode, isReferenceNode, isUserClassifierGroupNode, isUserClassifierNode } from "../../../classifier-service/Node";
import { ContextMenuItem, Icon } from "../../ContextMenuItem";
import { MenuLayout } from "./MenuLayout";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var TreeContextMenu = function TreeContextMenu(_ref) {
  var item = _ref.item,
      openState = _ref.openState,
      insertDisabledTitle = _ref.insertDisabledTitle,
      insertCount = _ref.insertCount,
      moveCount = _ref.moveCount,
      isSelfChecked = _ref.isSelfChecked,
      moveDisabledTitle = _ref.moveDisabledTitle,
      onCollapseAll = _ref.onCollapseAll,
      onClose = _ref.onClose,
      onCreateGroup = _ref.onCreateGroup,
      onEditGroup = _ref.onEditGroup,
      onCopyGroup = _ref.onCopyGroup,
      onPasteGroup = _ref.onPasteGroup,
      onDelete = _ref.onDelete,
      onInsertElements = _ref.onInsertElements,
      onMoveElements = _ref.onMoveElements,
      onFindAnywhere = _ref.onFindAnywhere,
      onDeleteSelected = _ref.onDeleteSelected,
      removeDisabledTitle = _ref.removeDisabledTitle,
      allowCreateGroup = _ref.allowCreateGroup,
      deleteAllCount = _ref.deleteAllCount,
      readonlyMode = _ref.readonlyMode,
      onCreateIssue = _ref.onCreateIssue,
      onLinkIssue = _ref.onLinkIssue,
      disabledIssue = _ref.disabledIssue,
      disabledInsertFilteredElements = _ref.disabledInsertFilteredElements,
      allowInsertFilteredElements = _ref.allowInsertFilteredElements,
      onInsertFilteredElements = _ref.onInsertFilteredElements,
      findAnyWhereDisabledTitle = _ref.findAnyWhereDisabledTitle,
      getAllowCreateFilterTitle = _ref.getAllowCreateFilterTitle,
      getAllowEditFilterTitle = _ref.getAllowEditFilterTitle,
      getAllowRemoveFilterTitle = _ref.getAllowRemoveFilterTitle,
      onCreateFilter = _ref.onCreateFilter,
      onEditFilter = _ref.onEditFilter,
      onRemoveFilter = _ref.onRemoveFilter,
      allowCreateTitle = _ref.allowCreateTitle,
      allowRemoveTitle = _ref.allowRemoveTitle,
      allowRenameTitle = _ref.allowRenameTitle,
      allowPasteGroup = _ref.allowPasteGroup,
      showRemoveFilter = _ref.showRemoveFilter,
      getAllowRemoveNodeTitle = _ref.getAllowRemoveNodeTitle,
      showCreateFilter = _ref.showCreateFilter,
      showEditFilter = _ref.showEditFilter,
      getAllowRemoveSeveralNodes = _ref.getAllowRemoveSeveralNodes,
      onInsertElementsFromSearch = _ref.onInsertElementsFromSearch,
      allowInsertElementsFromSearch = _ref.allowInsertElementsFromSearch,
      getCountElementsFromSearch = _ref.getCountElementsFromSearch;
  var withClose = useCallback( // eslint-disable-next-line @typescript-eslint/ban-types
  function withClose(handler) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
      onClose();
      handler.apply(void 0, arguments); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    };
  }, [onClose]);
  var findAnyWhere = React.useCallback(function (ref) {
    return /*#__PURE__*/_jsx(ContextMenuItem, {
      onClick: function onClick() {
        return withClose(onFindAnywhere)(ref);
      },
      "data-test-type": "menuItem",
      icon: Icon.SEARCH,
      disabled: !!findAnyWhereDisabledTitle,
      tooltipTitle: findAnyWhereDisabledTitle,
      children: "\u041D\u0430\u0439\u0442\u0438 \u0432\u0435\u0437\u0434\u0435"
    });
  }, [findAnyWhereDisabledTitle, onFindAnywhere, withClose]);
  var content = useMemo(function () {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (item !== null && item !== void 0 && item.ref && isUserClassifierGroupNode(item.ref)) {
      var allowCreateFilterTitle = getAllowCreateFilterTitle === null || getAllowCreateFilterTitle === void 0 ? void 0 : getAllowCreateFilterTitle(item.ref);
      var allowEditFilterTitle = getAllowEditFilterTitle === null || getAllowEditFilterTitle === void 0 ? void 0 : getAllowEditFilterTitle(item.ref);
      var allowRemoveFilterTitle = getAllowRemoveFilterTitle === null || getAllowRemoveFilterTitle === void 0 ? void 0 : getAllowRemoveFilterTitle(item.ref);
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [(allowInsertElementsFromSearch === null || allowInsertElementsFromSearch === void 0 ? void 0 : allowInsertElementsFromSearch(item.ref)) && onInsertElementsFromSearch && /*#__PURE__*/_jsxs(ContextMenuItem, {
          disabled: readonlyMode.enabled,
          tooltipTitle: readonlyMode.description,
          onClick: function onClick() {
            withClose(onInsertElementsFromSearch)(item.ref, item.path);
          },
          "data-test-type": "menuItem",
          icon: Icon.PASTE_FROM_SEARCH,
          children: [/*#__PURE__*/_jsx("div", {
            children: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043D\u0430\u0439\u0434\u0435\u043D\u043D\u044B\u0435"
          }), /*#__PURE__*/_jsxs("div", {
            children: ["\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B", ' ', getCountElementsFromSearch ? "(".concat(getCountElementsFromSearch(), ")") : '']
          })]
        }), onCreateFilter && (showCreateFilter ? showCreateFilter(item.ref) : true) && /*#__PURE__*/_jsx(ContextMenuItem, {
          disabled: readonlyMode.enabled || !!allowCreateFilterTitle,
          tooltipTitle: readonlyMode.description || allowCreateFilterTitle,
          onClick: function onClick() {
            withClose(onCreateFilter)(item.ref);
          },
          "data-test-type": "menuItem",
          icon: Icon.CREATE_FILTER,
          children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440"
        }), onEditFilter && (showEditFilter ? showEditFilter(item.ref) : true) && /*#__PURE__*/_jsx(ContextMenuItem, {
          disabled: readonlyMode.enabled || !!allowEditFilterTitle,
          tooltipTitle: readonlyMode.description || allowEditFilterTitle,
          onClick: function onClick() {
            withClose(onEditFilter)(item.ref);
          },
          "data-test-type": "menuItem",
          icon: Icon.EDIT_FILTER,
          children: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440"
        }), onRemoveFilter && (showRemoveFilter ? showRemoveFilter(item.ref) : true) && /*#__PURE__*/_jsx(ContextMenuItem, {
          disabled: readonlyMode.enabled || !!allowRemoveFilterTitle,
          tooltipTitle: readonlyMode.description || allowRemoveFilterTitle,
          onClick: function onClick() {
            withClose(onRemoveFilter)(item.ref);
          },
          "data-test-type": "menuItem",
          icon: Icon.REMOVE_FILTER,
          children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440"
        }), insertCount > 0 && /*#__PURE__*/_jsx(ContextMenuItem, {
          onClick: function onClick() {
            return withClose(onInsertElements)(item.ref);
          },
          disabled: readonlyMode.enabled || !!insertDisabledTitle,
          tooltipTitle: readonlyMode.description || insertDisabledTitle,
          "data-test-type": "menuItem",
          icon: Icon.PASTE,
          children: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B"
        }), allowInsertFilteredElements && onInsertFilteredElements && /*#__PURE__*/_jsx(ContextMenuItem, {
          disabled: readonlyMode.enabled || !!(disabledInsertFilteredElements !== null && disabledInsertFilteredElements !== void 0 && disabledInsertFilteredElements(item)),
          tooltipTitle: disabledInsertFilteredElements === null || disabledInsertFilteredElements === void 0 ? void 0 : disabledInsertFilteredElements(item),
          onClick: function onClick() {
            return withClose(onInsertFilteredElements)(item.ref);
          },
          "data-test-type": "menuItem",
          icon: Icon.PASTE,
          children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B \u0438\u0437 \u0432\u044C\u044E\u0432\u0435\u0440\u0430"
        }), moveCount > 0 && !isSelfChecked && /*#__PURE__*/_jsx(ContextMenuItem, {
          onClick: function onClick() {
            return withClose(onMoveElements)(item.ref);
          },
          disabled: readonlyMode.enabled || !!moveDisabledTitle,
          tooltipTitle: readonlyMode.description || moveDisabledTitle,
          "data-test-type": "menuItem",
          icon: Icon.MOVE,
          children: "\u041F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B"
        }), allowCreateGroup && /*#__PURE__*/_jsx(ContextMenuItem, {
          icon: Icon.CREATE,
          disabled: readonlyMode.enabled || !!allowCreateTitle,
          tooltipTitle: readonlyMode.description || allowCreateTitle,
          onClick: withClose(onCreateGroup),
          "data-test-type": "menuItem",
          children: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u0430\u043F\u043A\u0443"
        }), /*#__PURE__*/_jsx(ContextMenuItem, {
          disabled: readonlyMode.enabled || !!allowRenameTitle,
          tooltipTitle: readonlyMode.description || allowRenameTitle,
          onClick: withClose(onEditGroup),
          "data-test-type": "menuItem",
          icon: Icon.EDIT,
          children: "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C"
        }), onCopyGroup && /*#__PURE__*/_jsx(ContextMenuItem, {
          disabled: readonlyMode.enabled,
          tooltipTitle: readonlyMode.description,
          onClick: function onClick() {
            return withClose(onCopyGroup)(item.ref);
          },
          "data-test-type": "menuItem",
          icon: Icon.COPY,
          children: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0430\u043F\u043A\u0443"
        }), onPasteGroup && /*#__PURE__*/_jsx(ContextMenuItem, {
          disabled: readonlyMode.enabled || allowPasteGroup,
          tooltipTitle: readonlyMode.description,
          onClick: withClose(onPasteGroup),
          "data-test-type": "menuItem",
          icon: Icon.PASTE,
          children: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043F\u0430\u043F\u043A\u0443"
        }), !deleteAllCount && /*#__PURE__*/_jsx(ContextMenuItem, {
          disabled: readonlyMode.enabled || !!allowRemoveTitle || !!(getAllowRemoveNodeTitle !== null && getAllowRemoveNodeTitle !== void 0 && getAllowRemoveNodeTitle(item.ref)),
          tooltipTitle: readonlyMode.description || allowRemoveTitle || (getAllowRemoveNodeTitle === null || getAllowRemoveNodeTitle === void 0 ? void 0 : getAllowRemoveNodeTitle(item.ref)),
          onClick: function onClick() {
            withClose(onDelete)(item.ref);
          },
          "data-test-type": "menuItem",
          icon: Icon.DELETE,
          children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"
        }), onCreateIssue && /*#__PURE__*/_jsx(ContextMenuItem, {
          disabled: readonlyMode.enabled || disabledIssue,
          tooltipTitle: readonlyMode.description || disabledIssue && 'К папке уже привязано замечание',
          separatorTop: true,
          onClick: function onClick() {
            withClose(onCreateIssue)(item.path);
          },
          "data-test-type": "menuItem",
          icon: Icon.CREATE_ISSUE,
          children: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0437\u0430\u043C\u0435\u0447\u0430\u043D\u0438\u0435"
        }), onLinkIssue && /*#__PURE__*/_jsx(ContextMenuItem, {
          disabled: readonlyMode.enabled || disabledIssue,
          tooltipTitle: readonlyMode.description || disabledIssue && 'К папке уже привязано замечание',
          onClick: function onClick() {
            withClose(onLinkIssue)(item.path);
          },
          "data-test-type": "menuItem",
          icon: Icon.LINK_ISSUE,
          children: "\u041F\u0440\u0438\u0432\u044F\u0437\u0430\u0442\u044C \u0437\u0430\u043C\u0435\u0447\u0430\u043D\u0438\u0435"
        })]
      }); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } else if (item !== null && item !== void 0 && item.ref && isReferenceNode(item.ref)) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [findAnyWhere(item.ref), !deleteAllCount && !allowRemoveTitle && /*#__PURE__*/_jsx(ContextMenuItem, {
          onClick: function onClick() {
            return withClose(onDelete)(item.ref);
          },
          "data-test-type": "menuItem",
          icon: Icon.DELETE,
          disabled: readonlyMode.enabled || !!(getAllowRemoveNodeTitle !== null && getAllowRemoveNodeTitle !== void 0 && getAllowRemoveNodeTitle(item.ref)),
          tooltipTitle: readonlyMode.description || (getAllowRemoveNodeTitle === null || getAllowRemoveNodeTitle === void 0 ? void 0 : getAllowRemoveNodeTitle(item.ref)),
          children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"
        })]
      }); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } else if (item !== null && item !== void 0 && item.ref && isBimNode(item.ref)) {
      return findAnyWhere(item.ref);
    } else if ((item === null || item === void 0 ? void 0 : item.ref.type) === 'DynamicGeneratedGroupNode' || (item === null || item === void 0 ? void 0 : item.ref.type) === 'DynamicBimElementReferenceNode' || (item === null || item === void 0 ? void 0 : item.ref.type) === 'DynamicBaseGroupNode') {
      return findAnyWhere(item.ref); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } else if (item !== null && item !== void 0 && item.ref && isUserClassifierNode(item.ref)) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [moveCount > 0 && !isSelfChecked && /*#__PURE__*/_jsx(ContextMenuItem, {
          onClick: function onClick() {
            return withClose(onMoveElements)(item.ref);
          },
          disabled: readonlyMode.enabled || !!moveDisabledTitle,
          tooltipTitle: readonlyMode.description || moveDisabledTitle,
          "data-test-type": "menuItem",
          icon: Icon.MOVE,
          children: "\u041F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B"
        }), allowCreateGroup && /*#__PURE__*/_jsx(ContextMenuItem, {
          icon: Icon.CREATE,
          disabled: readonlyMode.enabled,
          tooltipTitle: readonlyMode.description,
          onClick: withClose(onCreateGroup),
          "data-test-type": "menuItem",
          children: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u0430\u043F\u043A\u0443"
        })]
      });
    }
  }, [item, getAllowCreateFilterTitle, getAllowEditFilterTitle, getAllowRemoveFilterTitle, allowInsertElementsFromSearch, onInsertElementsFromSearch, readonlyMode.enabled, readonlyMode.description, getCountElementsFromSearch, onCreateFilter, showCreateFilter, onEditFilter, showEditFilter, onRemoveFilter, showRemoveFilter, insertCount, insertDisabledTitle, allowInsertFilteredElements, onInsertFilteredElements, disabledInsertFilteredElements, moveCount, isSelfChecked, moveDisabledTitle, allowCreateGroup, allowCreateTitle, withClose, onCreateGroup, allowRenameTitle, onEditGroup, onCopyGroup, onPasteGroup, allowPasteGroup, deleteAllCount, allowRemoveTitle, getAllowRemoveNodeTitle, onCreateIssue, disabledIssue, onLinkIssue, onInsertElements, onMoveElements, onDelete, findAnyWhere]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(MenuLayout, {
      onClose: onClose,
      coords: openState,
      children: [/*#__PURE__*/_jsx(ContextMenuItem, {
        icon: Icon.COLLAPSE,
        onClick: withClose(onCollapseAll),
        "data-test-type": "menuItem",
        children: "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0432\u0441\u0435"
      }), content, !!deleteAllCount && /*#__PURE__*/_jsx(ContextMenuItem, {
        onClick: withClose(onDeleteSelected),
        "data-test-type": "menuItem",
        icon: Icon.DELETEALL,
        disabled: readonlyMode.enabled || !!removeDisabledTitle || !!(getAllowRemoveSeveralNodes !== null && getAllowRemoveSeveralNodes !== void 0 && getAllowRemoveSeveralNodes()),
        tooltipTitle: readonlyMode.description || removeDisabledTitle || (getAllowRemoveSeveralNodes === null || getAllowRemoveSeveralNodes === void 0 ? void 0 : getAllowRemoveSeveralNodes()),
        children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u044B\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0435"
      })]
    })
  });
}; // <ContextMenu>

/* {!isReferenceGroup && depsCheckedCount ? (
        <ContextMenuItem
          onClick={insertHandler}
          disabled={!!insertDisabled}
          tooltipTitle={insertDisabled}
          data-test-id='paste'
          icon={Icon.PASTE}
        >
          Вставить элементы
        </ContextMenuItem>
      ) : null} */

/* {!isReferenceGroup &&
      checkedCount &&
      checked !== 'PARENT_CHECKED' &&
      checked !== 'CHECKED' ? (
        <ContextMenuItem
          onClick={moveHandler}
          disabled={!!moveDisabled}
          tooltipTitle={moveDisabled}
          data-test-id='paste'
          icon={Icon.MOVE}
        >
          Переместить элементы
        </ContextMenuItem>
      ) : null} */

/* {!isReferenceGroup && (
        <ContextMenuItem
          disabled={
            !addable ||
            isMaxNestingLevel ||
            !!(
              isUserClassifierGroupNode(treeNode.node) && treeNode.node.source
            ) ||
            treeNode.node.type === 'UserClassifierGroupWithElementsNode'
          }
          tooltipTitle={addGroupTooltipTitle}
          onClick={addGroupHandler}
          data-test-id='addGroup'
          icon={Icon.CREATE}
        >
          Создать группу
        </ContextMenuItem>
      )} */

/* {!isReferenceGroup && (
        <ContextMenuItem
          disabled={
            !!(isUserClassifierGroupNode(treeNode.node) && treeNode.node.source)
          }
          onClick={setOnEditHandler}
          data-test-id='editGroup'
          icon={Icon.EDIT}
        >
          Переименовать
        </ContextMenuItem>
      )}
      {!deleteGroupTitle && (
        <ContextMenuItem
          onClick={removeHandler}
          data-test-id='deleteGroup'
          icon={Icon.DELETE}
        >
          Удалить
        </ContextMenuItem>
      )} */

/* {removeAll.active && (
        <ContextMenuItem
          icon={Icon.DELETEALL}
          tooltipTitle={removeAll.disabled}
          data-test-id='deleteAllElement'
          onClick={removeAllHandler}
          disabled={!!removeAll.disabled}
        >
          Удалить выделенные
        </ContextMenuItem>
      )} */
// </ContextMenu>